import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import people from 'data/people';
import ColleagueCard from 'components/app/directory/ColleagueCard';
import DirectoryService from 'components/app/directory/DirectoryService';
import useHeaderGenerator from '../../common/functions/useHeaderGenerator';
import { utils, writeFile } from 'xlsx';
//const followers = people.slice(0, 10);
import { useNavigate } from 'react-router-dom';
const WODMembers = () => {
  const [followers, setFollowers] = useState([]);
  const [exportToExcelData, setExportToExcelData] = useState([]);
  const navigate = useNavigate();
  const directoryPageDescription = '';
  const headerGenerated = useHeaderGenerator(
    'Members',
    directoryPageDescription,
    [
      {
        name: 'Add Athlete',
        type: 'submit',
        icon: 'plus',
        variant: 'primary',
        onClick: () => {
          console.log('Create a new Member');
          navigate('/app/wod/members/create-form/?role=WOD');
        }
      },
      {
        name: 'Import athletes',
        type: 'submit',
        variant: 'outline-secondary',
        onClick: () => {
          console.log('Import users');
          navigate('/app/wod/members/import');
        }
      },
      {
        name: 'Export to Excel',
        type: 'button',
        icon: 'rocket',
        variant: 'outline-success',
        onClick: () => {
          const data = exportToExcelData;
          const name = 'Users';
          let wb = utils.book_new();
          let ws = utils.json_to_sheet(data);
          utils.book_append_sheet(wb, ws, name);
          const fileName = name + '.xlsx';
          writeFile(wb, fileName);
        }
      },
      ,
      {
        name: 'Import history',
        type: 'submit',
        variant: 'outline-secondary',
        onClick: () => {
          console.log('Import users');
          navigate('/app/wod/members/history/import');
        }
      },
      {
        name: 'Add Coach',
        type: 'submit',
        icon: 'plus',
        variant: 'success',
        onClick: () => {
          console.log('Create a new Coach');
          navigate('/app/wod/members/create-form/?role=WOD-COACH');
        }
      }
    ]
  );
  useEffect(() => {
    setFollowers(people.slice(0, 20));
    DirectoryService.retrieveUsersByAccount().then(data => {
      setFollowers(data);
      const usersToExcelData = data.map(x => ({
      identifier: x.identifier,
      email: x.email,
      firstname: x.firstName,
      lastName: x.lastName
    }));
     setExportToExcelData(usersToExcelData);
    });
  }, []);

  return (
    <>
      {headerGenerated}
      {followers && (
        <Card>
          <Card.Body className="p-2">
            <Row className="g-2 text-center">
              {followers.map(colleague => (
                <Col
                  key={colleague.identifier}
                  xs={6}
                  lg={3}
                  xxl={2}
                  className="d-flex"
                >
                  <ColleagueCard
                    colleague={colleague}
                    linkToProfile="/app/wod/members"
                    onDelete={identifier =>
                      setFollowers(prev =>
                        prev.filter(f => f.identifier !== identifier)
                      )
                    }
                  />
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>
      )}
    </>
  );
};
export default WODMembers;
